import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import TitleSection from "../TitleSection/TitleSection";
import MenuCategory from "./MenuCategory";
import eatAndPlayConfig from "../../config/eatAndPlayConfig";

const TabContent = ({ categoryKey, t }) => {
  // const { t } = useTranslation();
  const categoryHeading = t(`eatAndPlay.${categoryKey}.heading`);
  const categoryDescription = t(`eatAndPlay.${categoryKey}.description`);

  // Get the appropriate config section based on the category
  const configSection = categoryKey.includes("Breakfast") ? "breakfast" : "main";
  const menuConfig = {
    ...eatAndPlayConfig[configSection],
    extras: eatAndPlayConfig.extras
  };

  return (
    <container-fluid>
      <TitleSection
        as={'h2'}
        title={t(categoryHeading)}
        text={t(categoryDescription)}
        className="pt-2"
      />
      <MenuGrid>
        {/* Render menu categories based on the config */}
        {Object.keys(eatAndPlayConfig[configSection]).map((sectionKey, index) => (
          <MenuGridItem key={index}>
            <MenuCategory
              menuSection={sectionKey}
              menuType={categoryKey}
              t={t}
              config={menuConfig}
            />
          </MenuGridItem>
        ))}
      </MenuGrid>
    </container-fluid>
  );
};

const MenuGrid = styled.div`
  column-count: 3;
  column-gap: 1.5rem;

  @media screen and (max-width: 991px) {
    column-count: 2;
  }

  @media screen and (max-width: 767px) {
    column-count: 1;
  }
`;

const MenuGridItem = styled.div`
  display: inline-block;
  width: 100%;
  break-inside: avoid;
`;

export default TabContent;
